import { render, staticRenderFns } from "./QuoteTemplateAvailableLabours.vue?vue&type=template&id=2589f784"
import script from "./QuoteTemplateAvailableLabours.vue?vue&type=script&lang=js"
export * from "./QuoteTemplateAvailableLabours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2589f784')) {
      api.createRecord('2589f784', component.options)
    } else {
      api.reload('2589f784', component.options)
    }
    module.hot.accept("./QuoteTemplateAvailableLabours.vue?vue&type=template&id=2589f784", function () {
      api.rerender('2589f784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quotetemplate/QuoteTemplateAvailableLabours.vue"
export default component.exports